export const Zhodino = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [28.278487, 54.10448],
            [28.279915, 54.09979],
            [28.2842, 54.095937],
            [28.287343, 54.093256],
            [28.2902, 54.089402],
            [28.2902, 54.08538],
            [28.292485, 54.07918],
            [28.299913, 54.074654],
            [28.306199, 54.070295],
            [28.313627, 54.065601],
            [28.319912, 54.062583],
            [28.329625, 54.06208],
            [28.341053, 54.06141],
            [28.350195, 54.06141],
            [28.361908, 54.062583],
            [28.366194, 54.063925],
            [28.370479, 54.068954],
            [28.376193, 54.069457],
            [28.38562, 54.070463],
            [28.38962, 54.071972],
            [28.391906, 54.07566],
            [28.390763, 54.080353],
            [28.387335, 54.086386],
            [28.385049, 54.091245],
            [28.382478, 54.096607],
            [28.381335, 54.101465],
            [28.382192, 54.106155],
            [28.384343, 54.107174],
            [28.371947, 54.114594],
            [28.373737, 54.115924],
            [28.373308, 54.115823],
            [28.374853, 54.117282],
            [28.37511, 54.117333],
            [28.374767, 54.119244],
            [28.367557, 54.122162],
            [28.355369, 54.124928],
            [28.330565, 54.128298],
            [28.332281, 54.113106],
            [28.320007, 54.113559],
            [28.312883, 54.107421],
            [28.31048, 54.109484],
            [28.30533, 54.113459],
            [28.290771, 54.109002],
            [28.280486, 54.106993],
            [28.278487, 54.10448],
          ],
        ],
      },
      properties: {
        shapeName: "Barysaw",
        shapeISO: "",
        shapeID: "67162791B39606099444015",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
